/* eslint-disable @typescript-eslint/no-unused-vars */
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export class AxTransparent extends Vue {
  inheritAttrs = false;

  @Prop()
  value: unknown;

  get listeners() {
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  get attrs() {
    const { rows, ...attrs } = this.$attrs;
    return attrs;
  }
}
